import { IPoint } from ".";

export interface ILocationSpecifiable<T = number> {
  location: IPoint<T>;
}

export function instanceOfILocationSpecifiable<T = number>(instance: any): instance is ILocationSpecifiable<T> {
  return instance
      && (instance.location !== undefined);
}
